<kmt-page>
  <div class="mb-4">
    <h1>Willkommen{{ portal.contact()?.name ? ', ' + portal.contact()?.name : '' }}</h1>
    @if (portal.contact(); as contact) {
      <p class="text-sm text-gray-500">Kontakt-Nr. {{ contact.pmNumber }}</p>
    }
  </div>

  @if (loadError()) {
    <p>
      Ihre Daten konnten nicht geladen werden. Bitte versuchen Sie es später erneut oder wenden Sie
      sich an Ihre Verwaltung.
    </p>
  } @else {
    <div class="flex flex-row flex-wrap justify-between items-center gap-2 mb-2">
      <h2>Ihr Verbrauch</h2>
      @if (unitOptions().length > 1) {
        <p-select
          [options]="unitOptions()"
          [ngModel]="selectedUnit()?.unitId ?? null"
          (ngModelChange)="selectedUnitId.set($event)"
          optionLabel="label"
          optionValue="value"
        />
      }
    </div>
    @if (consumptionCharts().length === 0) {
      <p class="mb-6 text-gray-500">Für Ihre Einheiten liegen noch keine Verbrauchsdaten vor.</p>
    } @else {
      <div class="flex flex-col gap-8 mb-8">
        @for (chart of consumptionCharts(); track chart.service) {
          <div>
            <h3 class="mb-2">
              {{ chart.label }} <span class="text-sm text-gray-500">({{ chart.unit }})</span>
            </h3>
            <div class="chart-wrapper">
              <p-chart type="bar" [data]="chart.data" [options]="chartOptions" />
            </div>
          </div>
        }
      </div>
    }

    <h2 class="mb-2">Ihre Einheiten</h2>
    <div class="table-scroll">
      <p-table [value]="portal.uviContracts()">
        <ng-template #header>
          <tr>
            <th>Adresse</th>
            <th>Einheit</th>
            <th>Vertrag von</th>
            <th>Vertrag bis</th>
          </tr>
        </ng-template>
        <ng-template #body let-contract>
          <tr>
            <td>{{ contract.address ?? '–' }}</td>
            <td>{{ contract.unitDisplayId }}</td>
            <td>{{ contract.validFrom | date: 'dd.MM.yyyy' }}</td>
            <td>
              {{ contract.validTo ? (contract.validTo | date: 'dd.MM.yyyy') : 'unbefristet' }}
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="4">Für Ihren Kontakt sind aktuell keine Einheiten hinterlegt.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</kmt-page>
